import React from 'react';
import { StarFavoriteIcon } from '@/components/icons/StarFavoriteIcon';
import { useAddFavoritePool } from '@/hooks/queries/usePoolQueries';
import { useUser } from '@/stores/authStore';
import { isInvestor } from '@/utils/user';

type InfoCardProps = {
  title: string;
  subtitle?: string;
  statusBadge?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  isFavorite: boolean;
  poolId: number;
};

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  subtitle,
  statusBadge,
  children,
  actions,
  isFavorite,
  poolId,
}) => {
  const user = useUser();
  const isInvestorUser = isInvestor(user);
  const addFavoritePoolMutation = useAddFavoritePool();
  const handleAddFavoritePool = (ev: React.MouseEvent<HTMLSpanElement>) => {
    ev.stopPropagation();
    ev.preventDefault();
    addFavoritePoolMutation.mutate({ poolId, isFavorite: !isFavorite });
  };

  return (
    <div className="w-full p-8 bg-white rounded-3xl border border-gray-200 flex flex-col justify-start items-start gap-8">
      {/* Header Section */}
      <div className="w-full flex justify-between items-center">
        <div>
          <div
            className="text-black text-2xl font-medium break-words"
            style={{
              fontFamily: 'var(--ep-font-avenir)',
            }}
          >
            {title}
          </div>
          {subtitle && (
            <div
              className="text-[#767676] text-sm font-normal mt-1"
              style={{
                fontFamily: 'var(--ep-font-avenir)',
              }}
            >
              {subtitle}
            </div>
          )}
        </div>
        <div className="flex items-start gap-2">
          {statusBadge}
          {isInvestorUser && (
            <StarFavoriteIcon onClick={handleAddFavoritePool} selected={isFavorite} className="w-8 h-8" />
          )}
        </div>
      </div>

      {/* Content */}
      {children}

      {/* Actions */}
      {actions && <div className="w-full flex justify-start items-center gap-4">{actions}</div>}
    </div>
  );
};
